import * as React from 'react';

import { toast as toastify } from 'react-toastify';

import { ToastView } from 'components/toast/toast.view';
import { ToastType } from 'components/toast/types';
import { DEFAULT_HIDE_DURATION } from 'utils/toast/constants';

export const toast = {
  ...toastify,
  info: (message: string) => {
    const autoClose = DEFAULT_HIDE_DURATION;
    const Wrapped = ({ ...props }) => (
      <ToastView type={ToastType.INFO} message={message} {...props} />
    );
    return toastify.info(Wrapped, {
      autoClose
    });
  },
  success: (message: string) => {
    const autoClose = DEFAULT_HIDE_DURATION;
    const Wrapped = ({ ...props }) => (
      <ToastView type={ToastType.SUCCESS} message={message} {...props} />
    );
    return toastify.success(Wrapped, {
      autoClose
    });
  },
  warn: (message: string) => {
    const autoClose = DEFAULT_HIDE_DURATION;
    const Wrapped = ({ ...props }) => (
      <ToastView type={ToastType.WARN} message={message} {...props} />
    );
    return toastify.warn(Wrapped, {
      autoClose
    });
  },
  error: (message: string) => {
    const autoClose = DEFAULT_HIDE_DURATION;
    const Wrapped = ({ ...props }) => (
      <ToastView type={ToastType.ERROR} message={message} {...props} />
    );
    return toastify.error(Wrapped, {
      autoClose
    });
  }
};
